<template>
  <CommonLayout header="DeliveryImageSpHeader" footer="ManagementFooter">
    <div class="container">
      <form method="post" action="#" class="form-horizontal light-gray">
        <div class="row base-color">
          <div class="col-sm-12 mt-3">
            <b-overlay :show="overlayShow" rounded="sm">
              <table class="table table-bordered base-color shadow">
                <tbody>
                  <tr>
                    <td class="light-blue sp-table">案件No.</td>
                    <td>{{weddingInfos.caseNumber}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue sp-table">施設</td>
                    <td>{{weddingInfos.facility}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue sp-table">会場</td>
                    <td>{{weddingInfos.venue}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue sp-table">挙式日</td>
                    <td>{{formatDate(weddingInfos.weddingDate)}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue sp-table">披露宴時間</td>
                    <td>{{weddingInfos.weddingTime}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue sp-table">ご両家名</td>
                    <td>{{weddingInfos.bothFamilyNames}}</td>
                  </tr>
                </tbody>
              </table>
            </b-overlay>
          </div>
          <div class="col-sm-12">
            <ul class="nav nav-tabs border-0">
              <li class="nav-item w-50">
                <button class="nav-link border-0 w-100" :class="activeTab === 'deliveryCompleteRegist' ? 'active main-color text-light' : 'gray-color text-dark'" type="button" @click="tabClick('deliveryCompleteRegist')">納品完了登録</button>
              </li>
              <li class="nav-item w-50">
                <button class="nav-link border-0 w-100" :class="activeTab === 'deliveryImageRegist' ? 'active main-color text-light' : 'gray-color text-dark'" type="button" @click="tabClick('deliveryImageRegist')">納品画像登録</button>
              </li>
            </ul>
            <div class="main-color h-5"></div>
            <div class="base-color shadow">
              <div v-if="activeTab === 'deliveryCompleteRegist'">
                <div class="col-sm-12 p-3">
                  <h3 class="text-center my-3">納品完了日時</h3>
                  <div class="col-8 offset-2">
                    <b-overlay :show="completeOverlayShow" rounded="sm">
                      <select class="form-control" v-model="deliveredCompleteDate" :disabled="this.projectStatus >= 8 && this.deliveredCompleteFlg">
                        <option
                          v-for="date in getDeliverableDate(weddingInfos.weddingDate)"
                          :value="date"
                          :key="date">
                          {{formatDate(date)}}
                        </option>
                      </select>
                      <div class="row m-0">
                        <select class="form-control my-3 col" v-model="deliveredCompleteHour" @click="setDefaultData($event, 10)" :disabled="this.projectStatus >= 8 && this.deliveredCompleteFlg">
                          <option
                            v-for="hour in getNumberArr({6: 22}, 1)"
                            :value="hour"
                            :key="hour" >
                            {{ hour }}
                          </option>
                        </select>
                        <span class="my-3 col-1">:</span>
                        <select class="form-control my-3 col" v-model="deliveredCompleteMinute" @click="setDefaultData($event, 0)" :disabled="this.projectStatus >= 8 && this.deliveredCompleteFlg">
                          <option
                            v-for="minute in getNumberArr({0: 55}, 5)"
                            :value="minute"
                            :key="minute" >
                            {{ minute }}
                          </option>
                        </select>
                      </div>
                    </b-overlay>
                    <b-button class="main-button-color text-light btn-block mb-3" @click="deliveredComplete" :disabled="this.projectStatus >= 8 && this.deliveredCompleteFlg">登録</b-button>
                  </div>
                </div>
              </div>
              <div class="py-2" v-else-if="activeTab === 'deliveryImageRegist'">
                <div class="col-sm-12 mt-3">
                  <h3 class="text-center">納品画像</h3>
                </div>
                <div class="col-sm-12 p-0">
                  <b-overlay :show="overlayShow" rounded="sm" class="p-3">
                    <div class="card-deck p-2 delivery-image-column-count" v-for="(imageInfo, index) in deliveryImageData()" :key="index">
                      <div class="card" v-for="(image, i) in imageInfo" :key="i">
                        <div class="card-header p-0 text-center card-sqr-gray tile-image-dev-mn" v-if="image.filePath !== null">
                          <img :src="image.filePath" class="mw-100 tile-image-height-mn">
                        </div>
                        <div class="card-header p-0" v-else>
                          <div class="tile-image-dev-mn text-center pt-3" v-if="image.type !== '06'">
                            <p class="mb-1">{{image.typeName}}</p>
                            <b-icon icon="image" font-scale="2"></b-icon>
                            <p>no Image</p>
                          </div>
                          <div class="tile-image-dev-mn text-center pt-4" v-else>
                            <b-icon icon="image" font-scale="2"></b-icon>
                            <p>no Image</p>
                          </div>
                        </div>
                        <div class="card-body p-0 small card-mlr">
                          <p class="card-title mb-1" v-if="image.type !== '06'">{{(i + 1) + (index * imageRowMaxNum)}}.{{image.typeName}}</p>
                          <p class="card-title mb-1" v-else>{{(i + 1) + (index * imageRowMaxNum)}}.{{image.typeName}}</p>
                          <p class="mb-1">任意</p>
                          <div class="row">
                            <div class="col">
                              <button v-if="image.filePath !== null" type="button" class="btn p-0 text-blue" @click="clickRotateImage(i + (index  * imageRowMaxNum))">
                                <b-icon icon="arrow-clockwise"></b-icon>
                              </button>
                              <button v-if="image.filePath === null" type="button" class="btn p-0" @click="clickRotateImage(i + (index  * imageRowMaxNum))" disabled>
                                <b-icon icon="arrow-clockwise"></b-icon>
                              </button>
                            </div>
                            <div class="text-right col text-nowrap pt-1">
                              <a class="text-blue" @click="clickUploadImage(i + (index  * imageRowMaxNum))" v-if="image.filePath === null">画像を登録</a>
                              <a class="text-blue" @click="clickDeleteImage(i + (index  * imageRowMaxNum))" v-else>画像クリア</a>
                              <input :id="'image-file-input-' + (i + (index  * imageRowMaxNum))" class="d-none" type="file" @change="uploadImage(i + (index  * imageRowMaxNum), $event)">
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="imageInfo.length < imageRowMaxNum">
                        <div class="card position-relative border-0 bg-unset h-300" v-for="i in (imageRowMaxNum - imageInfo.length)" :key="i"></div>
                      </template>
                    </div>
                  </b-overlay>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                      <label for="comment">コメント({{comment.length}}/{{consts.commentMaxLength}}文字)</label>
                      <b-overlay :show="commentOverlayShow" rounded="sm">
                        <textarea class="form-control" id="comment" rows="3" v-model="comment" :maxlength="consts.commentMaxLength"></textarea>
                      </b-overlay>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="text-center mb-3">
                    <b-button variant="primary" class="text-light w-25 ml-3" @click="regist">登録</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <CommonModal title="" body="登録が完了しました" ref="commonModal"/>
    </div>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import DeliveredImageModel from '@/models/DeliveredImageModel'
import DeliveredCompleteModel from '@/models/DeliveredCompleteModel'
import imageCompression from 'browser-image-compression'

export default {
  name: 'DeliveredImageSp',
  components: { CommonLayout, CommonModal },
  data () {
    return {
      overlayShow: false,
      completeOverlayShow: false,
      commentOverlayShow: false,
      activeTab: '',
      deliveredCompleteFlg: false,
      deliveredCompleteDate: '',
      deliveredCompleteHour: '',
      deliveredCompleteMinute: '',
      isComplete: false,
      imageRowMaxNum: 2,
      projectNumber: null,
      projectStatus: null,
      weddingInfos: {},
      deleteImageInfos: [],
      imageInfos: [],
      comment: ''
    }
  },
  computed: {
    getNumberArr: function () {
      return function (range, step) {
        const start = Object.keys(range)[0]
        const end = range[start]
        const arrCount = ((end - start) / step) + 1
        let array = [...Array(arrCount)].map((_, i) => Number(i * step) + Number(start))
        if (array[0] === 0) {
          array[0] = '00'
          array[1] = '05'
        }
        if (array[0] === 6) {
          array[0] = '06'
          array[1] = '07'
          array[2] = '08'
          array[3] = '09'
        }
        return array
      }
    }
  },
  methods: {
    setApiData: async function () {
      this.overlayShow = true
      this.commentOverlayShow = true
      const reqData = { 'projectNumber': this.projectNumber }
      DeliveredImageModel.getApi(this.$bvModal, reqData, (result) => {
        if ('items' in result) {
          this.imageInfos = result['items'].map(elm => {
            elm['isAddFile'] = false
            return elm
          })
        }
        this.weddingInfos = result['projectInfo']
        this.comment = result['deliveredCompleteComment']

        this.setProjectStatus(result['projectInfo']['status'])

        this.isComplete = result['isComplete']
        this.activeTab = 'deliveryCompleteRegist'
        if (this.isComplete) {
          this.activeTab = 'deliveryImageRegist'
        }
      },
      () => {
        this.overlayShow = false
        this.commentOverlayShow = false
      })

      this.completeOverlayShow = true
      DeliveredCompleteModel.getApi(this.$bvModal, reqData, (result) => {
        if ('deliveredCompleteDatetime' in result &&
          'date' in result['deliveredCompleteDatetime'] &&
          'time' in result['deliveredCompleteDatetime']) {
          const times = result['deliveredCompleteDatetime']['time'].split(':')
          this.deliveredCompleteDate = result['deliveredCompleteDatetime']['date']
          this.deliveredCompleteHour = times[0]
          this.deliveredCompleteMinute = times[1]
          this.deliveredCompleteFlg = (this.deliveredCompleteDate && this.deliveredCompleteHour && this.deliveredCompleteMinute)
        }
      },
      () => {
        this.completeOverlayShow = false
      })
    },
    tabClick (tabName) {
      this.activeTab = tabName
    },
    deliveryImageData () {
      if (!this.imageInfos) {
        return null
      }
      const length = Math.ceil(this.imageInfos.length / this.imageRowMaxNum)
      const images = new Array(length).fill().map((_, i) =>
        this.imageInfos.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
      return images
    },
    regist: async function () {
      if (this.comment.length > this.consts.commentMaxLength) {
        this.$refs.commonModal.confirmBox('コメントの文字数がオーバーしています')
        return false
      }

      this.overlayShow = true
      this.commentOverlayShow = true
      let reqData = {
        'projectNumber': this.projectNumber
      }

      this.imageInfos.forEach(imageInfo => {
        if (reqData['regist'] === undefined) {
          reqData['regist'] = []
        }

        if (imageInfo.filePath) {
          reqData['regist'].push({
            'filePath': imageInfo.filePath,
            'imageType': imageInfo.type,
            'displayOrderNumber': imageInfo.displayOrder,
            'isAddFile': imageInfo.isAddFile
          })
        }
      })

      this.deleteImageInfos.forEach(deleteImageInfo => {
        if (reqData['delete'] === undefined) {
          reqData['delete'] = []
        }

        reqData['delete'].push(deleteImageInfo)
      })

      reqData['comment'] = this.comment

      DeliveredImageModel.postApi(this.$bvModal, reqData, (result) => {
        this.imageInfos = result['items'].map(elm => {
          elm['isAddFile'] = false
          return elm
        })
        this.deleteImageInfos = []
        this.$refs.commonModal.confirmBox('納品画像の登録が完了しました')
      },
      () => {
        this.overlayShow = false
        this.commentOverlayShow = false
      })
    },
    clickUploadImage (index) {
      document.getElementById('image-file-input-' + index).click()
    },
    clickDeleteImage (index) {
      if (!this.imageInfos[index].isAddFile) {
        this.deleteImageInfos.push(this.imageInfos[index].filePath)
      }
      this.imageInfos[index]['filePath'] = null
      this.imageInfos[index]['isAddFile'] = false
    },
    clickRotateImage: async function (index) {
      this.overlayShow = true

      const reqData = {
        'projectNumber': this.projectNumber,
        'imagePath': this.imageInfos[index].filePath,
        'imageType': this.imageInfos[index].type,
        'isAddFile': this.imageInfos[index].isAddFile
      }

      DeliveredImageModel.putApi(this.$bvModal, reqData, (result) => {
        this.imageInfos[index].filePath = result.images.imagePath
      },
      () => {
        this.overlayShow = false
      })
    },
    uploadImage: async function (index, e) {
      if (typeof e.target.files[0] === 'undefined') {
        return false
      }

      this.overlayShow = true
      this.commentOverlayShow = true

      const file = e.target.files[0]
      const extend = file.name.match(/[^.]+$/)[0]
      if (['PNG', 'png', 'JPG', 'JPEG', 'jpg', 'jpeg', 'GIF', 'gif'].includes(extend) === false) {
        this.$refs.commonModal.confirmBox('アップロード可能なファイル形式はjpeg・jpg・png・gifのみです。')
        this.overlayShow = false
        this.commentOverlayShow = false
        return false
      }
      const options = {
        maxSizeMB: 5,
        maxWidthOrHeight: 1280,
        useWebWorker: true
      }
      const compressedFile = await imageCompression(file, options)

      const dataUrl = await this.toDataUrl(compressedFile)

      const reqData = {
        'projectNumber': this.projectNumber,
        'fileName': file.name,
        'imageType': this.imageInfos[index].type,
        'imageData': dataUrl.replace(/^.*,/, '')
      }

      DeliveredImageModel.uploadApi(this.$bvModal, reqData, (result) => {
        this.imageInfos[index].filePath = result.items.filePath
        this.imageInfos[index].isAddFile = true
      },
      () => {
        this.overlayShow = false
        this.commentOverlayShow = false
      })
    },
    toDataUrl (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
      })
    },
    setDefaultData (e, setValue) {
      // e.target.value = setValue
    },
    deliveredComplete: async function () {
      if (!this.deliveredCompleteDate) {
        this.$refs.commonModal.confirmBox('納品完了日を選択してください。')
        return false
      }
      if (this.compareDate(this.deliveredCompleteDate)) {
        this.$refs.commonModal.confirmBox('納品日に未来の日付は入力できません。')
        return false
      }
      if (!this.deliveredCompleteHour || !this.deliveredCompleteMinute) {
        this.$refs.commonModal.confirmBox('納品完了時間を選択してくください。')
        return false
      }

      this.completeOverlayShow = true

      const reqData = {
        'projectNumber': this.projectNumber,
        'status': (this.projectStatus === 7) ? '案件セット印刷済' : (this.projectStatus === 6) ? '制作依頼完了' : '納品完了',
        'deliveredCompleteDate': this.deliveredCompleteDate,
        'deliveredCompleteTime': this.deliveredCompleteHour + ':' + this.deliveredCompleteMinute
      }

      DeliveredCompleteModel.postApi(this.$bvModal, reqData, (result) => {
        this.$refs.commonModal.confirmBox('納品完了登録しました')
        this.setApiData()
      },
      () => {
        this.completeOverlayShow = false
      })
    },
    handleResize () {
      if (window.innerWidth < 576) {
        this.imageRowMaxNum = 2
      } else if (window.innerWidth < 768) {
        this.imageRowMaxNum = 3
      } else if (window.innerWidth < 992) {
        this.imageRowMaxNum = 4
      } else {
        this.imageRowMaxNum = 5
      }
    },
    setProjectStatus (data) {
      const status = {
        '施設成約済': 1,
        '打合せ日程確定': 2,
        '打合せ中': 3,
        '打合せ完了': 4,
        'レシピ編集済み': 4,
        'レシピ組み完了': 5,
        '制作依頼完了': 6,
        '案件セット印刷済': 7,
        '納品完了': 8,
        '売上日報完了': 9,
        '変更依頼': 15,
        '他社成約済': 20,
        'キャンセル': 30
      }
      this.projectStatus = (data in status) ? status[data] : 0
    },
    getDeliverableDate (date) {
      // 挙式日とその前日の配列を取得
      const newDate = new Date(date)
      const yesterday = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() - 1)
      let format = 'YYYY-MM-DD'
      format = format.replace(/YYYY/, yesterday.getFullYear())
      format = format.replace(/MM/, yesterday.getMonth() + 1 >= 10 ? yesterday.getMonth() + 1 : '0' + (yesterday.getMonth() + 1))
      format = format.replace(/DD/, yesterday.getDate() >= 10 ? yesterday.getDate() : '0' + yesterday.getDate())
      const deliverableDate = {
        format,
        date
      }
      return deliverableDate
    },
    formatDate (date) {
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW)'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      return format
    },
    compareDate (date) {
      let dateList = date.split('-')
      let year = dateList[0]
      let month = dateList[1]
      let day = dateList[2]

      const newDate = new Date(year, month - 1, day).setHours(0, 0, 0, 0)
      const today = new Date().setHours(0, 0, 0, 0)
      console.log(newDate)
      console.log(today)
      return newDate > today
    }
  },
  mounted () {
    this.projectNumber = this.$route.params.projectNumber
    this.setApiData()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }
}
</script>
<style>
.mw-100 {
  max-width: 100%;
}
.tile-image-dev-mn {
  height: 124px;
}
.tile-image-height-mn {
  max-height: 124px;
  height: auto;
}
.card-sqr-gray {
  border-radius: 0 !important;
  background-color: #ddd !important;
}
.card-mlr {
  margin: 0px 5px 0px 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/DeliveredImageSp.vue